const generalNotFoundErrorMessage = 'お探しのデータが見つかりませんでした';
const generalInternalServerErrorMessage = 'システムエラーが発生しました。しばらく時間をおいて再度お試しください';
const generalForbiddenErrorMessage = 'アクセス権限がありません';
const generalValidationErrorMessage = '入力内容に誤りがあります。入力項目をご確認ください';
export { generalNotFoundErrorMessage, generalValidationErrorMessage, generalInternalServerErrorMessage, generalForbiddenErrorMessage, };
//# sourceMappingURL=message.js.map